import { render } from "./Roll.vue?vue&type=template&id=976c29bc&scoped=true"
import script from "./Roll.vue?vue&type=script&lang=js"
export * from "./Roll.vue?vue&type=script&lang=js"

import "./Roll.vue?vue&type=style&index=0&id=976c29bc&scoped=true&lang=css"

import exportComponent from "E:\\Data\\Repos\\Propnroll\\Propnroll\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-976c29bc"]])

export default __exports__